import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import ModuloEnum from "@/core/utils/ModuloEnum"

const componentRouterView = {
    render(c) {
        return c("router-view");
    },
};
const createRegisterRoute = ({
    baseUrl,
    name,
    titleList,
    listComponent,
    menu,
    othersRoutes = [],
}) => ({
    path: baseUrl,
    component: componentRouterView,
    children: [
        {
            path: "/",
            name: `listar${name}`,
            meta: { description: titleList, menu },
            component: listComponent,
        },
        ...othersRoutes,
    ],
});

const routes = {
    path: "/Patrimonio",
    component: componentRouterView,
    meta: {
        moduleName: "Patrimônio",
        icon: "archive",
        modulo: ModuloEnum.PATRIMONIO,
        sistema: 2,
    },
    children: [
        createRegisterRoute({
            baseUrl: "historicotombamento",
            name: "HistoricoTombamento",
            titleList: "Histórico de Tombamento",
            listComponent: () =>
                import("./historico-tombamento/HistoricoTombamentoList.vue"),
            menu: { name: "Historico de Tombamento", permissao: PrivilegiosEnum.ITEM_BEM_PERMANENTE_EDITAR },
        }),

        createRegisterRoute({
            baseUrl: "historicolotacao",
            name: "HistoricoLotacao",
            titleList: "Historico de Lotação",
            listComponent: () =>
                import("./historicolotacao/HistoricoLotacaoList.vue"),
            menu: { name: "Historico de Lotação", permissao: PrivilegiosEnum.LOTACAO_BEM_PERMANENTE_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "consulta-item-bem-permanente",
            name: "ConsultaItemBemPermanente",
            titleList: "Consulta Item Bem Permanente",
            listComponent: () =>
                import(
                    "./consulta-item-bem-permanente/ConsultaItemBemPermanenteList.vue"
                ),
            menu: { name: "Consulta Item Bem Permanente", permissao: PrivilegiosEnum.INVENTARIO_ANUAL_ACESSAR },

            othersRoutes: [
            ],
        }),

        createRegisterRoute({
            baseUrl: "historico-carga-patrimonial",
            name: "historicoCargaPatrimonial",
            titleList: "Historico Carga Patrimonial",
            listComponent: () =>
                import(
                    "./historico-carga-patrimonial/HistoricoCargaPatrimonialList.vue"
                ),
            menu: { name: "Histórico Carga Patrimonial", permissao: PrivilegiosEnum.HISTORICO_CARGA_PATRIMONIAL_ACESSAR },
            othersRoutes: [
            ],
        }),

        createRegisterRoute({
            baseUrl: "historico-edicao-item-bem-permanente",
            name: "historicoalteracaoitemBemPermanente",
            titleList: "Histórico Edição Item Bem Permanente",
            listComponent: () =>
                import("./historico-edicao-item-bem-permanente/HistoricoEdicaoItemBemPermanenteList.vue"),
            menu: { name: "Histórico Edição Item Bem Permanente", permissao: PrivilegiosEnum.HISTORICO_EDICAO_IBP_ACESSAR },
            othersRoutes: [],
        }),

        createRegisterRoute({
            baseUrl: "inventariofiltro",
            name: "inventariofiltro",
            titleList: "Inventário e Divergências",
            listComponent: () =>
                import("./inventariofiltro/InventarioDivergenciasList.vue"),
            menu: { name: "Inventário e Divergências", permissao: PrivilegiosEnum.INVENTARIO_DIVERGENCIAS_ACESSAR },
            othersRoutes: [],
        }),


        createRegisterRoute({
            baseUrl: "item-bem-permanente",
            name: "itemBemPermanente",
            titleList: "Item Bem Permanente",
            listComponent: () =>
                import("./item-bem-permanente/ItemBemPermanenteList.vue"),
            menu: { name: "Item Bem Permanente", permissao: PrivilegiosEnum.ITEM_BEM_PERMANENTE_ACESSAR },
            othersRoutes: [],
        }),

        createRegisterRoute({
            baseUrl: "catalogo-consulta",
            name: "catalogoConsulta",
            titleList: "Consulta Catálogo",
            listComponent: () =>
                import("./catalogo-consulta/CatalogoConsultaList.vue"),
            menu: { name: "Consulta Catálogo", permissao: PrivilegiosEnum.CATALOGO_PATRIMONIO_ACESSAR },
            othersRoutes: [
            ],
        }),
        createRegisterRoute({
            baseUrl: "bem-terceiro",
            name: "BemTerceiro",
            titleList: "Bem Terceiro",
            listComponent: () => import("./bem-terceiro/BemTerceiroList.vue"),
            menu: { name: " Bem Terceiro ", permissao: PrivilegiosEnum.BEM_TERCEIRO_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "emprestimo",
            name: "emprestimo",
            titleList: "Empréstimo Item Bem Permanente",
            listComponent: () => import("./emprestimo/EmprestimoList.vue"),
            menu: { name: " Empréstimo Item Bem Permanente ", permissao: PrivilegiosEnum.EMPRESTIMO_BEM_PERMANENTE_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "solicitacao-manutencao",
            name: "SolicitacaoManutencao",
            titleList: "Solicitação de Manutenção",
            titleCreate: "Solicitacao Manutencao>> Cadastrar >> Item Bem Permanente",
            listComponent: () =>
                import("./solicitacao-manutencao/SolicitacaoManutencaoList.vue"),
            menu: { name: " Solicitação de Manutenção ", permissao: PrivilegiosEnum.SOLICITACAO_MOVIMENTACAO_ACESSAR },

        }),

        createRegisterRoute({
            baseUrl: "solicitacao-movimentacao",
            name: "SolicitacaoMovimentacao",
            titleList: "Solicitação de Movimentação",
            listComponent: () =>
                import("./solicitacao-movimentacao/SolicitacaoMovimentacaoList.vue"),
            formComponent: () =>
                import("./solicitacao-movimentacao/SolicitacaoMovimentacaoForm.vue"),
            menu: { name: "Solicitação de Movimentação", permissao: PrivilegiosEnum.SOLICITACAO_MOV_ACESSAR },
            othersRoutes: [
            ],
        }),

        createRegisterRoute({
            baseUrl: "manuais-roteiros-atos",
            name: "ManuaisRoteirosAtosPatrimonio",
            titleList: "Manuais, Roteiros e Atos",
            listComponent: () =>
                import("../almoxarifados/manuais-roteiros-atos/ManuaisRoteirosAtosList.vue"),
            menu: { name: "Manuais, Roteiros e Atos", permissao: PrivilegiosEnum.MANUAIS_ROTEIROS_ATOS_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "devolucao-movimentacao-simplificada",
            name: "DevolucaoMovimentacaoSimplificada",
            titleList: "Devolucao/Movimentação Simplificada",
            listComponent: () =>
                import(
                    "./devolucao-movimentacao-simplificada/DevolucaoMovimentacaoSimplificadaList.vue"
                ),
            menu: { name: "Devolução/Movimentação Simplificada ", permissao: PrivilegiosEnum.DEVOLUCAO_MOVIMENTACAO_SIMPLIFICADA_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "inventario-anual",
            name: "inventarioAnual",
            titleList: "Inventário Anual",
            listComponent: () => import("./inventario-anual/InventarioAnualList.vue"),
            menu: { name: " Inventário Anual ", permissao: PrivilegiosEnum.ITEM_BEM_PERMANENTE_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "solicitacao-inventario",
            name: "SolicitacaoInventario",
            titleList: "Solicitação de Inventário",

            listComponent: () =>
                import("./solicitacao-inventario/SolicitacaoInventarioList.vue"),
            menu: { name: " Solicitação de Inventário", permissao: PrivilegiosEnum.SOLICITACAO_INVENTARIO_BEM_PERMANENTE_ACESSAR },
            othersRoutes: [
            ],
        }),
        createRegisterRoute({
            baseUrl: "inventario-item-bem-permanente",
            name: "InventarioItemBemPermanente",
            titleList: "Inventário Item Bem Permanente",
            listComponent: () =>
                import(
                    "./inventario-item-bem-permanente/InventarioItemBemPermanenteList.vue"
                ),
            menu: { name: "Inventário Item Bem Permanente", permissao: PrivilegiosEnum.AUDIT_BEM_PERMANENTE_ACESSAR },
            othersRoutes: [
            ],
        }),
        createRegisterRoute({
            baseUrl: "baixa-item-bem-permanente",
            name: "BaixaItemBemPermanente",
            titleList: "Baixa Item Bem Permanente",
            listComponent: () =>
                import(
                    "./baixa-item-bem-permanente/BaixaItemBemPermanenteList.vue"
                ),
            menu: { name: "Baixa Item Bem Permanente", permissao: PrivilegiosEnum.BAIXA_BEM_PERMANENTE_ACESSAR },
            othersRoutes: [
            ],
        }),

        createRegisterRoute({
            baseUrl: "impressao-etiqueta",
            name: "impressao-etiqueta",
            titleList: "Impressão de Etiqueta",
            listComponent: () =>
                import("./impressao-etiqueta/ImpressaoEtiquetaList.vue"),
            menu: { name: "Impressão de Etiqueta", permissao: PrivilegiosEnum.IMPRESSAO_ETIQUETA_ACESSAR },
            othersRoutes: [],
        }),

        createRegisterRoute({
            baseUrl: "monitoramento_rfid_antenas",
            name: "monitoramento_rfid_antenas",
            titleList: "Monitoramento RFID - Antenas",
            listComponent: () =>
                import("./monitoramento-rfid/MonitoramentoRfidList.vue"),
            menu: { name: "Monitoramento RFID - Antenas", permissao: PrivilegiosEnum.MONITORAMENTO_RFID_ANTENAS_ACESSAR },
            othersRoutes: [],
        }),

        createRegisterRoute({
            baseUrl: "migracao_dados_planilha",
            name: "migracao_dados_planilha",
            titleList: "Migração de Dados - Planilha",
            listComponent: () =>
                import("./migracao-planilha/MigracaoPlanilha.vue"),
            menu: { name: "Migração de Dados - Planilha", permissao: PrivilegiosEnum.MIGRACAO_DADOS_PLANILHA_ACESSAR },
            othersRoutes: [],
        }),

    ],
};

export default routes;
